import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DatalayerService, NotificationType, JoinPipe } from '@woolworthsnz/styleguide';
import { RecipeSearchRequest } from '@woolworthsnz/trader-api';
import { prioritiseMealTimes } from '../../helpers';
import { RouterLink } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';

const MAX_MEAL_TIMES = 2;

@Component({
	selector: 'recipe-meal-times',
	template: `
		<ul
			id="recipe-{{ id }}-mealTimes"
			attr.aria-label="Suitable for {{ prioritisedMealTimes | join: ', ':' and ' }} meals."
		>
			<li *ngFor="let mealTime of prioritisedMealTimes">
				<a
					*ngIf="link; else justText"
					routerLink="/recipes/search"
					[queryParams]="{ target: mealTimesSearchTarget, q: mealTime }"
					(click)="handleMealTimeClick(mealTime)"
				>
					{{ mealTime }}
				</a>
				<ng-template #justText>
					{{ mealTime }}
				</ng-template>
			</li>
		</ul>
	`,
	styleUrls: ['./meal-times.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgFor, NgIf, RouterLink, JoinPipe]
})
export class MealTimesComponent {
	@Input() id: number;
	@Input() mealTimes: string[] = [];
	@Input() limit = false;
	@Input() link: boolean;
	@Input() title: string;

	mealTimesSearchTarget: RecipeSearchRequest.TargetEnum = 'Mealtimes';

	constructor(private datalayerService: DatalayerService) { }

	get prioritisedMealTimes(): string[] {
		return this.limit
			? prioritiseMealTimes(this.mealTimes.map((mealTime) => mealTime.trim())).slice(0, MAX_MEAL_TIMES)
			: prioritiseMealTimes(this.mealTimes.map((mealTime) => mealTime.trim()));
	}

	handleMealTimeClick(mealTime: string): void {
		if (!this.link) {
			return;
		}

		this.datalayerService.trackRecipeEvent(NotificationType.Link, `RDP_mealtime_${mealTime.toLowerCase()}`, this.id);
	}
}
